import React from 'react';

function RUIcon({ w, h, style, className }) {
  return (
    <svg
      className={className}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width={w}
      height={h}
      viewBox="0 0 18 18"
      style={style}
    >
      <defs>
        <filter
          id="a"
          width="118.8%"
          height="118.8%"
          x="-9.4%"
          y="-9.4%"
          filterUnits="objectBoundingBox"
        >
          <feOffset in="SourceAlpha" result="shadowOffsetOuter1" />
          <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation=".5" />
          <feColorMatrix
            in="shadowBlurOuter1"
            result="shadowMatrixOuter1"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.296705163 0"
          />
          <feMerge>
            <feMergeNode in="shadowMatrixOuter1" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
      </defs>
      <g fill="none" fillRule="nonzero" filter="url(#a)" transform="translate(1 1)">
        <circle cx="8" cy="8" r="8" fill="#D80027" />
        <g fill="#F0F0F0">
          <path d="M7.672 6.537l.657.905 1.063-.345L8.734 8l.657.904-1.063-.346-.657.904V8.345L6.61 8l1.063-.344z" />
          <path d="M5.881 10.26a2.26 2.26 0 1 1 1.075-4.25 2.783 2.783 0 1 0 0 3.978 2.25 2.25 0 0 1-1.075.273z" />
        </g>
      </g>
    </svg>
  );
}

RUIcon.defaultProps = {
  w: 18,
  h: 18,
  style: {},
  fill: '#000000',
};

export default RUIcon;
